import Xrp from './Xrp';

export default Xrp;
